export function applyVelocity(object, { isSolid, time }) {
  if (!isSolid({ x: object.x, y: object.y })) {
    const deltaVX = object.velocity.x * time.deltaTime
    const deltaVY = object.velocity.y * time.deltaTime

    if (
      isSolid({
        x: object.x + deltaVX,
        y: object.y + deltaVY,
      })
    )
      object.velocity.x = object.velocity.y = 0
    else {
      if (isSolid({ x: object.x, y: object.y + deltaVY })) object.velocity.y = 0
      if (isSolid({ x: object.x + deltaVX, y: object.y })) object.velocity.x = 0
    }
  }

  const result = {
    x0: object.x,
    y0: object.y,
    x1: object.x + object.velocity.x * time.deltaTime,
    y1: object.y + object.velocity.y * time.deltaTime,
  }

  object.x = result.x1
  object.y = result.y1

  return result
}
